module.exports = __webpack_public_path__ + "img/350.36b70056.png";